import { FondsPropresService } from "src/app/fonds-propres/services/fonds-propres.service";
import { startWith, switchMap, map, catchError } from "rxjs/operators";
import { merge, Observable, of as observableOf } from "rxjs";
import { ItemCreditComponent } from "./item-credit/item-credit.component";
import { PortefeuilleDetail } from "./../../../models/PortefeuilleDetail";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
} from "@angular/core";
import { Portefeuille } from "./../../../models/Portefeuille";

@Component({
  selector: "app-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"],
})
export class DetailsComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: PortefeuilleDetail[];
  isLoadingResults = true;

  resultsLength = 0;
  isRateLimitReached = false;
  displayedColumns = [
    "codeDossier",
    "nomClient",
    "libelleSegmentPrudentiel",
    "creanceSaine",
    "creanceEnSouffrance",
    "provision",
    "montantPretRestant",
    "montantEngagementHorsBilan",
    "nombreGarantie",
    "cumulActifPondereRisque",
    "fondPropreAssocie",
    "actions",
  ];

  portefeuilleId: number;

  @Input("portefeuille")
  portefeuille: Portefeuille;

  constructor(
    private modalService: NgbModal,
    private shared: FondsPropresService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.portefeuille) {
      this.portefeuilleId = this.portefeuille.id;
      this.getPortefeuilleDetails(this.portefeuilleId, "", 0);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("eeeee");
    if (!this.portefeuille) return;

    if (changes.portefeuille.isFirstChange()) return;

    this.portefeuilleId = this.portefeuille.id;
    this.getPortefeuilleDetails(this.portefeuilleId, "", 0);
  }

  //View row in modal popup
  ViewPortefeuilleDetail(row) {
    const modalRef = this.modalService.open(ItemCreditComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-app-modal-class",
    });
    modalRef.componentInstance.portefeuilleDetail = row;
    modalRef.componentInstance.portefeuilleId = this.portefeuille.id;

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        //this.getPortefeuilleDetails(this.portefeuilleId);
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  getPortefeuilleDetails(
    portefeuilleId: number,
    filter: String,
    pageIndex: number
  ): void {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = pageIndex)
    );

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this.shared.getPortefeuilleDetails(
            portefeuilleId,
            filter,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map((data) => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((data) => (this.dataSource = data));
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getPortefeuilleDetails(
      this.portefeuilleId,
      filterValue.trim().toLowerCase(),
      0
    );
    //this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  valuechange(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.trim() == "" || filterValue.trim() == null) {
      this.getPortefeuilleDetails(this.portefeuilleId, "", 0);
    }
  }
}
